import { cn } from "@/utils";
import type { HTMLAttributes } from "react";
import { HermesThemeContext, type HermesTheme } from "./hermesTheme";
import { HermesToaster } from "./HermesToaster";

type HermesScreenProps = HTMLAttributes<HTMLDivElement> & {
  theme?: HermesTheme;
};

/**
 * Raiz de toda tela do Hermes. É ela que liga os tokens `hermes-*` (a classe
 * `.hermes`), e por isso nada do Hermes funciona fora dela.
 */
export const HermesScreen = ({
  theme = "light",
  className,
  children,
  ...props
}: HermesScreenProps) => (
  // `relative`: todo texto escondido (`sr-only`, posição absoluta) dentro da tela fica contido nela. Sem isso ele
  // escapa do scroll interno e estica o body, e a tela ganha um segundo scroll.
  <HermesThemeContext.Provider value={theme}>
    <div
      data-theme={theme}
      className={cn("hermes relative", className)}
      {...props}
    >
      {children}
      <HermesToaster theme={theme} />
    </div>
  </HermesThemeContext.Provider>
);
